export default __webpack_public_path__ + "static/media/whisper-oval-carbon-mtb.cf37e42f.glb";